<script>
     export let msg = "Loading"
</script>

<style>
     .loader {
          text-align: center;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translateX(-50%) translateY(-50%);
          width: 100%;
     }
     h2 {margin-top: 0;
          font-size:25px;
        font-size: 2.5rem;
        margin-bottom: .25em;
        font-weight: 300;
        opacity: .75;
     }
</style>

<div class="loader">
     <div class="lds-ripple"><div></div><div></div></div>
     <h2>{ msg }</h2>
</div>